module.exports = __webpack_public_path__ + "static/cad-designs7-023c2ab4b03771b6370db7e74132659c.png";